const ZINDEXES = {
    page: 1,
    header: 2,
    aside: 3,
    backdrop: 4,
    modal: 5
}

export default ZINDEXES;